import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VListItem,
    {
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _c(
        VListItemIcon,
        [_c(VIcon, { staticClass: "ui-icon-log-out" })],
        1
      ),
      _vm._v(" "),
      _c(
        VListItemContent,
        [
          _c(VListItemTitle, { staticClass: "text-body-1 text--text" }, [
            _vm._v("\n      " + _vm._s(_setup.translate("Выйти")) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            VListItemSubtitle,
            { staticClass: "text-body-2 text-info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.translate("на всех устройствах")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }